import styled from '@emotion/styled'

export const Main = styled.main`
  padding: 1rem 1rem 0 1rem;
`
